import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={30}
    height={29}
    viewBox="0 0 30 29"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="M29.11 28.41h-1.14c-14.89 0-27-12.11-27-27V.27h10.47l1.85 8.57-6.03 6.02a24.87 24.87 0 0 0 6.71 6.89l5.57-5.18 9.59 2.19v9.65h-.02ZM15.96 23c3.24 1.81 6.93 2.91 10.86 3.09v-5.51l-6.63-1.51-4.23 3.94V23ZM3.28 2.55c.17 3.69 1.15 7.17 2.77 10.27l4.73-4.72-1.19-5.55H3.28Z"
    />
  </Svg>
);
export default SvgComponent;
